<ion-header>
  <ion-toolbar>
    <ion-title>Join Team</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="dialog-container">
    <h2>What is your relationship to this team?</h2>
    <p class="subtext">
      The privacy and security of young athletes is our top priority, so family
      and players must be approved.
    </p>

    <div class="button-group">
      <ion-button *ngIf="canFollow" expand="block" fill="outline" class="option-btn"
                  (click)="onSelect('fan')">I'm a fan</ion-button>
      <ion-button *ngIf="!isUserTeamPlayer" expand="block" fill="outline" class="option-btn"
                  (click)="onSelect('player')">I'm a player</ion-button>
      <ion-button *ngIf="!isOwner" expand="block" fill="outline" class="option-btn"
                  (click)="onSelect('staff')">I'm a staff</ion-button>
    </div>
  </div>
</ion-content>
